import axiosClient from "./axiosClient";

const inventoryApi = {
  addVariantInventory: (id, payload) => {
    axiosClient.put(`/api/inventory/add-variant-inventory/${id}`, payload);
  },
};

export default inventoryApi;
